module.exports = __webpack_public_path__ + "static-portal/img/banner7.86e7ac1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner7.jpg
// module id = xsFP
// module chunks = 4